import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { api } from '../api/client';
import { DemandaForm } from '../components/demandas/DemandaForm';
import { useAuth } from '../contexts/AuthContext';

export function NovaDemandaPage() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [secretarias, setSecretarias] = useState([]);

  const podeEscolherSecretaria = user?.perfil !== 'secretario';

  useEffect(() => {
    api.get('/secretarias').then((r) => setSecretarias(r.secretarias));
  }, []);

  // Os arquivos sobem ANTES de criar a demanda: assim, se um upload falhar
  // (tipo não suportado, arquivo grande, rede), o erro aparece no formulário e
  // o usuário não perde nada. Antes o upload rodava depois da criação dentro
  // de um `catch {}` vazio — a demanda nascia sem a imagem e ninguém ficava
  // sabendo (foi o que aconteceu em 08/09 com a Lorraine).
  const handleSubmit = async (payload, arquivos, setProgresso) => {
    const lista = Array.from(arquivos || []);
    const enviados = [];
    for (let i = 0; i < lista.length; i++) {
      const arquivo = lista[i];
      try {
        setProgresso?.({ nome: arquivo.name, indice: i + 1, total: lista.length, pct: 0 });
        const up = await api.upload('/uploads', arquivo, (pct) =>
          setProgresso?.({ nome: arquivo.name, indice: i + 1, total: lista.length, pct })
        );
        enviados.push({ url: up.url, nome: up.originalName, mime: up.mime, tamanho: up.size });
      } catch (e) {
        setProgresso?.(null);
        throw new Error(
          `Não consegui enviar a imagem "${arquivo.name}": ${e.data?.error || e.message}. ` +
          'Remova esse arquivo da lista e envie a demanda, ou tente de novo.'
        );
      }
    }
    setProgresso?.(null);

    const { demanda } = await api.post('/demandas', payload);

    const naoVinculados = [];
    for (const anexo of enviados) {
      try {
        await api.post(`/demandas/${demanda.codigo}/anexos`, anexo);
      } catch {
        naoVinculados.push(anexo.nome);
      }
    }
    nav(`/demandas/${demanda.codigo}`, naoVinculados.length ? { state: { anexosFalharam: naoVinculados } } : undefined);
  };

  return (
    <div className="page">
      <button className="btn btn-ghost" style={{ marginBottom: 12 }} onClick={() => nav(-1)}>
        <ArrowLeft size={16} /> Voltar
      </button>
      <div className="page-header">
        <div>
          <h1 className="page-title">Nova Demanda</h1>
          <p className="page-subtitle">Preencha os detalhes do que precisa ser comunicado. A equipe será notificada.</p>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <DemandaForm
            secretarias={secretarias}
            mostrarSecretaria={podeEscolherSecretaria}
            onSubmit={handleSubmit}
            onCancel={() => nav('/')}
          />
        </div>
      </div>
    </div>
  );
}
